import { useState, useEffect } from "react"
import './OrganizationBuild.less'
import { Modal, Toast } from "dingtalk-design-mobile"
import { _test } from '@/api/user';
import { setCommand } from "@/utils/jsapi-auth";
import copy from 'copy-to-clipboard'
import userIdMap from '@/const'
  
const OrganizationBuild = () => {
  // useEffect(() => {
  //   _test()
  // }, [])
  const [list, setList] = useState([
    {
      name: '企业建会',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-01.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/1.%E5%B7%A5%E4%BC%9A%E7%BB%84%E5%BB%BA%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
    {
      name: '工会换届',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-02.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/2.%E5%B7%A5%E4%BC%9A%E6%8D%A2%E5%B1%8A%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
    {
      name: '工会注销',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-03.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/3.%E5%B7%A5%E4%BC%9A%E5%8A%9E%E7%90%86%E6%B3%95%E4%BA%BA%E8%B5%84%E6%A0%BC%E6%B3%A8%E9%94%80%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
    {
      name: '工会信息变更',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-04.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/4.%E5%B7%A5%E4%BC%9A%E4%BF%A1%E6%81%AF%E5%8F%98%E6%9B%B4%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
    {
      name: '工会申请组织移交',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-04.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/5.%E5%B7%A5%E4%BC%9A%E6%B3%95%E4%BA%BA%E8%B5%84%E6%A0%BC%E8%AF%81%E4%B9%A6%E9%81%97%E5%A4%B1%E8%A1%A5%E5%8A%9E%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
    {
      name: '工会法人资格证书遗失补办',
      icon: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/organization/icon-04.png',
      url: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/file/6.%E5%B7%A5%E4%BC%9A%E7%94%B3%E8%AF%B7%E7%BB%84%E7%BB%87%E7%A7%BB%E4%BA%A4%E6%89%8B%E7%BB%AD%E5%BA%94%E6%8F%90%E4%BA%A4%E8%B5%84%E6%96%99%EF%BC%88%E9%99%84%E4%BB%B6%EF%BC%89.zip'
    },
  ])

  const handleChat = () => {
    setCommand('openChatByUserId', {
      userId: userIdMap['lqy']
    })
  }

  const handleDownload = (url) => {
    Modal.alert(
      '',
      '请用手机浏览器打开链接下载资料',
      [
        { text: '取消', onClick: () => {} },
        { text: '复制链接', onClick: () => {
          Toast.success({
            content: '复制成功',
            duration: 2
          })
          copy(url)
        } },
      ]
    )
  }
  return (
    <div className="pg-organization-build">
      {
        list.map((item,index) => {
          return (
            <div className="row" key={index}>
              <div className="row-left">
                <img className="icon" src={item.icon} />
                <div>{ item.name }</div>
              </div>
              <div className="row-right" onClick={() => handleDownload(item.url)}>下载模板</div>
            </div>
          )
        })
      }
      <div className="title">温馨提示：</div>
      <div className="tip">下载模板，资料填写好之后，点击【联系审核人员】发送资料</div>
      <div onClick={handleChat} className="link">联系审核人员</div>
    </div>
  )
}

export default OrganizationBuild